import { TypedDocumentNode } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import {
  CloudControllerMutationsIdentifyReaderArgs,
  CloudControllerMutationsOpenDoorArgs,
  Mutation
} from 'graphql/generated/graphqlTypes';
import { IDENTIFY_READER, OPEN_DOOR } from 'graphql/v2/mutations';
import { ignoreHandledMutationError } from 'utils/Mutation/ignoreHandledMutationError';
import { TranslatedHookProps } from '../hooks.types';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const OPEN_DOOR_TYPED: TypedDocumentNode<
  Pick<Mutation, 'cloudController'>,
  CloudControllerMutationsOpenDoorArgs
> = OPEN_DOOR;
const IDENTIFY_READER_TYPED: TypedDocumentNode<
  Pick<Mutation, 'cloudController'>,
  CloudControllerMutationsIdentifyReaderArgs
> = IDENTIFY_READER;

const useCloudControllers = ({ translation, handleFetchError }: TranslatedHookProps) => {
  const [openDoorMutation, { loading: openingDoor }] = useMutation(OPEN_DOOR_TYPED, {
    onError: () => handleFetchError(translation.open_door_error)
  });

  const openDoor = async (doorId: string): Promise<boolean> => {
    const { data } = await ignoreHandledMutationError(openDoorMutation({ variables: { doorId } }));
    return !!data?.cloudController.openDoor;
  };

  const [identifyReaderMutation, { loading: identifyingReader }] = useMutation(IDENTIFY_READER_TYPED, {
    onError: () => handleFetchError(translation.identify_reader_error)
  });

  const identifyReader = async (doorId: string): Promise<boolean> => {
    const { data } = await ignoreHandledMutationError(identifyReaderMutation({ variables: { doorId } }));
    return !!data?.cloudController.identifyReader;
  };

  return {
    openDoor,
    openingDoor,
    identifyReader,
    identifyingReader
  };
};

export default useCloudControllers;
